import { render } from "./Regression.vue?vue&type=template&id=150638e0&scoped=true"
import script from "./Regression.vue?vue&type=script&lang=js"
export * from "./Regression.vue?vue&type=script&lang=js"

import "./Regression.vue?vue&type=style&index=0&id=150638e0&lang=scss&scoped=true"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150638e0"]])

export default __exports__